// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YrJO","option":"styles_option__1NaZR","selected":"styles_selected__1oYn3"};